function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

require('xps-style/core/tabs.css');

var propTypes = {
  active: PropTypes.bool,
  ariaControls: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,

  /** Size (height) of the tab (small: 32px, medium: 40px, large: 48px) */
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};
var defaultProps = {
  active: false,
  onClick: function onClick() {},
  size: 'small'
};

var Tab = function Tab(_ref) {
  var active = _ref.active,
      ariaControls = _ref.ariaControls,
      children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      name = _ref.name,
      onClick = _ref.onClick,
      size = _ref.size;

  var handleClick = function handleClick() {
    onClick(name);
  };

  var getClassNames = function getClassNames() {
    var _classnames;

    return classnames((_classnames = {}, _defineProperty(_classnames, className, className), _defineProperty(_classnames, "tab__item", true), _defineProperty(_classnames, 'tab__item-skin', true), _defineProperty(_classnames, "tab__item--".concat(size), true), _defineProperty(_classnames, 'tab__item--active', active), _classnames));
  };

  return /*#__PURE__*/React.createElement("button", {
    role: "tab",
    "aria-selected": active,
    "aria-controls": ariaControls,
    id: id,
    type: "button",
    className: getClassNames(),
    onClick: handleClick,
    tabIndex: active ? 0 : -1
  }, name, children);
};

Tab.propTypes = propTypes;
Tab.defaultProps = defaultProps;
Tab.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tab",
  "props": {
    "active": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "size": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Size (height) of the tab (small: 32px, medium: 40px, large: 48px)"
    },
    "ariaControls": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    }
  }
};
export default Tab;